import { ClaseModel } from "./clase.model";
import { EjercicioModel } from "./ejercicio.model";

export class RutinaModel {
    activo: boolean;
    nombre: string;
    nivel: string;
    sexo: string;
    detalle: EjercicioModel[] | ClaseModel[];
    totalEjercicios: number;
    propietario: string;
    empresaId: string;
}

export const sexosRutina: string[] = [
    'General', 
    'Hombre', 
    'Mujer', 
]